<template>
  <div>
    <nav class="navbar navbar-expand-lg fixed-top">
      <div class="row" v-if="this.isLoggedIn()" style="width:100%">
        <div class="col-1">
          <router-link to="/home" class="nav-link">Home</router-link>
        </div>
        <div class="col-1">
          <router-link to="/request" class="nav-link">진단의뢰</router-link>
        </div>

        <div class="col-1" v-if="this.isManager()">
          <router-link :to="{path:'/request_manage', query:{t:Date.now()}}" class="nav-link" :key="$route.fullPath">진단의뢰관리</router-link>
        </div>

        <div class="col-1" v-if="this.isManager()">
          <router-link to="/screen_manage_list" class="nav-link">진단검사관리</router-link>
        </div>

        <div class="col-1">
          <router-link to="/screen_list" class="nav-link">진단검사결과</router-link>
        </div>

        <div class="col-1 dropdown" v-if="this.isManager()" @mouseenter="showStatsSubmenu = true" @mouseleave="showStatsSubmenu = false">
          <router-link to="/optstatviewmanager" class="nav-link dropdown-toggle" :class="{ 'show': showStatsSubmenu }">통계관리</router-link>
          <div class="dropdown-menu" :class="{ 'show': showStatsSubmenu }" @mouseenter="showStatsSubmenu = true" @mouseleave="showStatsSubmenu = false">
            <router-link class="dropdown-item" to="/optstatviewmanager">통계관리</router-link>
            <router-link class="dropdown-item" to="/optstatviewmanager_hospitals">병원별 통계</router-link>
            <router-link class="dropdown-item" to="/optstatviewmanager_patients">환자별 통계</router-link>
            <router-link class="dropdown-item" to="/optstatviewmanager_areascreen">지역별 통계</router-link>
          </div>
        </div>

        <div class="col-1">
          <router-link to="/optstatview" class="nav-link">통계</router-link>
        </div>

        <div class="col-4" v-if="!this.isManager()">
        </div>
        <div class="col-1" v-else>
          </div>
        <div class="col-3">
          <div class="disp_muted_info" style="vertical-align:middle">
            {{store.getters['userStore/getUserEmail']}} {{store.getters['userStore/getUserHospitalName']}}
          </div>
        </div>
        <div class="col-1">
          <a href="#" class="nav-link" @click.prevent="onLogout">Logout</a>
        </div>
      </div>

      <div class="row" style="width:100%" v-else> 
        <div class="col-1">
          <router-link to="/home" class="nav-link">Home</router-link>
        </div>
        <div class="col-1">
          <router-link to="/optstatview" class="nav-link">통계</router-link>
        </div>

        <div class="col-8">
        </div>
        <div class="col-1">
          <router-link to="/login" class="nav-link">Login</router-link>
        </div>
        <div class="col-1">
          <router-link to="/usersignup" class="nav-link">Sign up</router-link>
        </div>
      </div>
    </nav>

    <table border=0 height="40px">
      <tr>
        <td height="40px">
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'; // 👈 useRouter import
import {mapActions} from 'vuex'
const userStore = 'userStore'

export default {
  name: 'MainHeader',
  data() {
    //let userrole = ref('')

    return {
      //userrole
      showStatsSubmenu: false
    }
  },
  computed : {

  },
  mounted:function(){

  },
  methods: {
    ...mapActions(userStore,['logout']),
    isLoggedIn : function(){
      //alert('userStore:isLoggedIn()')
      //console.log('MainHeader:isLoggedIn()')

      return this.store.getters['userStore/isLogin'];
      //return this.isLogin
    },
    isManager:function(){
      //console.log('MainHeader:isManager()')
      return this.store.getters['userStore/isManager'];

    },
    onLogout (){
      //alert ('MainHeader:onLogout()');
      this.logout();
      // 2. 로그인 페이지로 강제 라우팅
      // 'router'는 setup()에서 반환되어 this에 접근 가능합니다.
      this.router.push('/login');

    },


  },
  setup(){
    const store = useStore();
    const router = useRouter(); // 👈 useRouter 사용
    return {store, router} // 👈 router 반환
     
  }
}
</script>

<style scoped>
@import '@/assets/base.css';

.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  min-width: 160px;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.9em;
  color: #ffffff;
  font-family: NotoSansKR-Black !important;
  text-align: left;
  list-style: none;
  background-color: #0b2463;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
}

.dropdown-menu.show {
  display: block;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1rem;
  clear: both;
  font-weight: 400;
  color: #ffffff;
  font-family: NotoSansKR-Black !important;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: #ddddff;
  background-color: transparent;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
</style>
